import type { ComponentProps } from "react";
import { DateField } from "@apac/core-form-ui";

export const PassportExpiryDateField = (
  props: ComponentProps<typeof DateField>
) => {
  return <DateField {...props} />;
};
